/* Keeps the free luggage scale in the cart: one scale per FlyBag backpack. */
(function () {
  const BAG_PRODUCT_ID = 14944480428418;
  const SCALE_VARIANT_ID = 56998305431938;
  const SCALE_HANDLE = 'digitalis-borondmerleg-ajandek';
  const BAG_HANDLE = '/products/flybag';
  const TOTAL_LABEL = 'Végösszeg';
  const CHECKOUT_LABEL = 'Vásárlás befejezése';
  const CHECKOUT_NOTE = 'Az árak tartalmazzák az adókat. A megrendelés fizetési kötelezettséggel jár.';
  // Colour split in the cart: the customer sets how many bags of each colour they want.
  const COLORS = [
    { id: 55309458506114, name: 'Fekete', swatch: '#111111' },
    { id: 55309930234242, name: 'Barna', swatch: '#8b5a2b' },
  ];
  let running = false;

  // Writes the scale quantity onto its cart row so CSS can show "Ajándék × N" instead of quantity controls.
  function decorate() {
    document.querySelectorAll(`.cart-item a[href*="${SCALE_HANDLE}"]`).forEach((link) => {
      const row = link.closest('.cart-item');
      const cell = row && row.querySelector('.cart-item__quantity');
      const input = row && row.querySelector('.quantity__input');
      if (cell && input && cell.dataset.fbQty !== input.value) cell.dataset.fbQty = input.value;
    });

    // Quantity discount titles are generic; show the real bag count on the cart rows instead.
    // A row has two links (image and title), so count each row once.
    let bags = 0;
    new Set([...document.querySelectorAll(`.cart-item a[href*="${BAG_HANDLE}"]`)].map((a) => a.closest('.cart-item'))).forEach((row) => {
      const input = row.querySelector('.quantity__input');
      bags += input ? Number(input.value) || 0 : 0;
    });
    const percent = bags >= 4 ? 30 : bags === 3 ? 20 : 15;
    const discountLabel = `${bags} db FlyBag – ${percent}% mennyiségi kedvezmény`;
    document.querySelectorAll('.cart-item .discounts__discount').forEach((item) => {
      const text = [...item.childNodes].reverse().find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
      if (text && /FlyBag/.test(text.textContent) && text.textContent.trim() !== discountLabel) text.textContent = discountLabel;
    });

    renderColorPicker();

    document.querySelectorAll('.totals__total').forEach((heading) => {
      if (heading.textContent.trim() !== TOTAL_LABEL) heading.textContent = TOTAL_LABEL;
    });

    // Checkout button label, with the tax / payment-obligation note directly under it (drawer and cart page).
    document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach((button) => {
      if (button.textContent.trim() !== CHECKOUT_LABEL) button.textContent = CHECKOUT_LABEL;
    });
    document.querySelectorAll('.cart__ctas').forEach((ctas) => {
      const scope = ctas.closest('.drawer__footer, .cart__blocks') || ctas.parentElement;
      let placed = ctas.nextElementSibling && ctas.nextElementSibling.classList.contains('tax-note') ? ctas.nextElementSibling : null;
      scope.querySelectorAll('.tax-note').forEach((note) => {
        if (note === placed) return;
        if (placed) {
          note.remove();
        } else {
          ctas.after(note);
          placed = note;
        }
      });
      if (placed && placed.textContent.trim() !== CHECKOUT_NOTE) placed.textContent = CHECKOUT_NOTE;
    });
  }

  // Per-colour quantity steppers under the cart items (drawer and cart page). Re-run on every re-render.
  function renderColorPicker() {
    document.querySelectorAll('table.cart-items, .cart-items').forEach((table) => {
      if (!table.matches('table')) return;
      const qty = {};
      COLORS.forEach((c) => {
        qty[c.id] = 0;
        table.querySelectorAll(`.quantity__input[data-quantity-variant-id="${c.id}"]`).forEach((input) => {
          qty[c.id] += Number(input.value) || 0;
        });
      });
      const total = COLORS.reduce((sum, c) => sum + qty[c.id], 0);
      let box = table.nextElementSibling && table.nextElementSibling.classList.contains('fb-colors') ? table.nextElementSibling : null;
      if (!total) {
        if (box) box.remove();
        return;
      }
      if (!box) {
        box = document.createElement('div');
        box.className = 'fb-colors';
        box.innerHTML =
          '<p class="fb-colors__title">Színek kiválasztása</p>' +
          '<p class="fb-colors__hint">Állítsd be, hány fekete és hány barna táskát kérsz.</p>' +
          COLORS.map(
            (c) =>
              `<div class="fb-colors__row" data-variant="${c.id}">` +
              `<span class="fb-colors__swatch" style="background:${c.swatch}"></span>` +
              `<span class="fb-colors__name">${c.name}</span>` +
              '<span class="fb-colors__stepper">' +
              '<button type="button" class="fb-colors__btn" data-step="-1" aria-label="Kevesebb">−</button>' +
              '<span class="fb-colors__qty">0</span>' +
              '<button type="button" class="fb-colors__btn" data-step="1" aria-label="Több">+</button>' +
              '</span></div>'
          ).join('');
        box.addEventListener('click', onColorStep);
        table.after(box);
      }
      if (box.dataset.busy) return;
      COLORS.forEach((c) => {
        const row = box.querySelector(`[data-variant="${c.id}"]`);
        // Only touch the DOM on a real change, or the body MutationObserver would loop.
        const label = row.querySelector('.fb-colors__qty');
        if (label.textContent !== String(qty[c.id])) label.textContent = qty[c.id];
        const minus = row.querySelector('[data-step="-1"]');
        if (minus.disabled !== (qty[c.id] === 0)) minus.disabled = qty[c.id] === 0;
      });
    });
  }

  async function onColorStep(event) {
    const button = event.target.closest('.fb-colors__btn');
    const box = event.currentTarget;
    if (!button || box.dataset.busy) return;
    const row = button.closest('.fb-colors__row');
    const next = Math.max(0, Number(row.querySelector('.fb-colors__qty').textContent) + Number(button.dataset.step));
    box.dataset.busy = '1';
    box.classList.add('is-busy');
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [row.dataset.variant]: next } }),
      });
      const refreshed = await syncGift();
      if (!refreshed) await refreshCartUi();
    } catch (e) {
      console.error('FlyBag colour split', e);
    } finally {
      delete box.dataset.busy;
      box.classList.remove('is-busy');
      decorate();
    }
  }

  async function refreshCartUi() {
    if (window.location.pathname.replace(/\/$/, '') === '/cart') {
      window.location.reload();
      return;
    }
    const res = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
    const sections = await res.json();
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      const fresh = doc.querySelector('#CartDrawer');
      const current = drawer.querySelector('#CartDrawer');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const freshDrawer = doc.querySelector('cart-drawer');
      if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const section = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (section) bubble.innerHTML = section.innerHTML;
    }
  }

  async function syncGift() {
    if (running) return false;
    running = true;
    try {
      const cart = await (await fetch('/cart.js')).json();
      let bags = 0;
      let scales = 0;
      cart.items.forEach((item) => {
        if (item.product_id === BAG_PRODUCT_ID) bags += item.quantity;
        if (item.variant_id === SCALE_VARIANT_ID) scales += item.quantity;
      });
      if (bags === scales) return false;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [SCALE_VARIANT_ID]: bags } }),
      });
      await refreshCartUi();
      return true;
    } catch (e) {
      console.error('FlyBag gift sync', e);
      return false;
    } finally {
      running = false;
    }
  }

  function init() {
    decorate();
    let pending = null;
    new MutationObserver(() => {
      clearTimeout(pending);
      pending = setTimeout(decorate, 30);
    }).observe(document.body, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(syncGift, 50));
    }
    syncGift();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
